export var NavVariants = {
  "default": 'default',
  simple: 'simple',
  horizontal: 'horizontal',
  tertiary: 'tertiary'
};